import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sheet, SheetContent } from '../../components/ui/sheet';
import { useAppUIContext } from '../../context/AppUIContext';
import { useResponsive } from '../../hooks/useResponsive';
import LeftMenu from './LeftMenu';
import Page from '../../const/Page';

interface AppLayoutProps {
    children: ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const { isMobileMenuOpen, setIsMobileMenuOpen } = useAppUIContext();
    const { isSidebarCollapsed } = useResponsive();
    const location = useLocation();

    const path = location.pathname;
    const isSidebarHidden = (
        path.startsWith(Page.publicSharePage) ||
        path.startsWith(Page.publicBotPage)
    );

    // Close mobile menu on route change
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname, setIsMobileMenuOpen]);

    return (
        <div className={`flex h-screen w-full overflow-hidden ${isSidebarCollapsed ? 'bg-background' : 'bg-[#F0F0F2] p-4 gap-4'}`}>
            {/* Desktop Sidebar */}
            {!isSidebarCollapsed && !isSidebarHidden && (
                <aside className="w-[304px] shrink-0 bg-white rounded-panel border border-[#E5E5E5] h-full overflow-hidden">
                    <LeftMenu />
                </aside>
            )}

            {/* Mobile Sidebar */}
            {isSidebarCollapsed && (
                <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
                    <SheetContent side="left" className="p-0 w-[304px] border-r-0" hideClose>
                        <LeftMenu />
                    </SheetContent>
                </Sheet>
            )}

            {/* Main Content - 자식 컴포넌트가 직접 패널 스타일 관리 */}
            <main className="flex-1 h-full overflow-hidden relative">
                {children}
            </main>
        </div>
    );
};
